var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status",class:("status--" + _vm.status)},[_vm._v(_vm._s(_vm._f("translate")(("status." + _vm.status))))])}
var staticRenderFns = []

export { render, staticRenderFns }